export default __webpack_public_path__ + "static/media/booking-com.ed2ed434.svg";